import React from 'react'
import { Select, Text } from '@/components'
import { APIClient } from '@/services'
import { useProfilePrompt } from '../../useProfilePrompt'
import { RenderItemProps } from '../types'
import { BaseCard } from './BaseCard'

export const LearningMotivationsCard = ({ item }: RenderItemProps) => {
  const { data: options } = APIClient.Session.useProfileOptions()
  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <Select
        {...prompt.form.register('learning_motivations')}
        options={options?.motivations}
        variants={['noError', 'prompt']}
        arrowIconName="chevron-right"
        placeholder="Select an option"
        multiple
        onMenuOpen={() => BaseCard.setOpenPortal(prompt, true)}
        onMenuClose={() => BaseCard.setOpenPortal(prompt, false)}
        HeaderComponent={() => (
          <Text
            variants={['h4', 'color:neutral5', 'paddingLeft:3', 'paddingTop:2', 'paddingBottom:1']}
            text="Select all that apply"
          />
        )}
      />
    </BaseCard>
  )
}
